var React = require('react');

function Bg2Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Tracé_96","data-name":"Tracé 96","d":"M0,0H195a22,22,0,0,1,22,22v96.717a138.483,138.483,0,0,1-33.932,18.278C163.568,144.066,139,147,139,147A139,139,0,0,1,0,8Z","fill":"#eea0c3"}));
}

Bg2Inline.defaultProps = {"width":"217","height":"147","viewBox":"0 0 217 147"};

module.exports = Bg2Inline;

Bg2Inline.default = Bg2Inline;
